import {createFromIconfontCN} from "@ant-design/icons-vue";
import {UploadFile} from "ant-design-vue";
import {defineComponent} from "vue";

export type Json = { [key: string]: unknown }
export const IconFont = createFromIconfontCN({scriptUrl: require('@/assets/font/iconfont.js')})

export const printWelcome = (): void => {
    // ASCII - ANSI Shadow
    const text = `
                                                                                                                                                                                                      
                                                                                                                                                                                                      
HHHHHHHHH     HHHHHHHHH                                        DDDDDDDDDDDDD                                                                    BBBBBBBBBBBBBBBBB                                     
H:::::::H     H:::::::H                                        D::::::::::::DDD                                                                 B::::::::::::::::B                                    
H:::::::H     H:::::::H                                        D:::::::::::::::DD                                                               B::::::BBBBBB:::::B                                   
HH::::::H     H::::::HH                                        DDD:::::DDDDD:::::D                                                              BB:::::B     B:::::B                                  
  H:::::H     H:::::H  uuuuuu    uuuuuu     ooooooooooo          D:::::D    D:::::D    ooooooooooo   nnnn  nnnnnnnn       ggggggggg   ggggg       B::::B     B:::::B  aaaaaaaaaaaaa     ooooooooooo   
  H:::::H     H:::::H  u::::u    u::::u   oo:::::::::::oo        D:::::D     D:::::D oo:::::::::::oo n:::nn::::::::nn    g:::::::::ggg::::g       B::::B     B:::::B  a::::::::::::a  oo:::::::::::oo 
  H::::::HHHHH::::::H  u::::u    u::::u  o:::::::::::::::o       D:::::D     D:::::Do:::::::::::::::on::::::::::::::nn  g:::::::::::::::::g       B::::BBBBBB:::::B   aaaaaaaaa:::::ao:::::::::::::::o
  H:::::::::::::::::H  u::::u    u::::u  o:::::ooooo:::::o       D:::::D     D:::::Do:::::ooooo:::::onn:::::::::::::::ng::::::ggggg::::::gg       B:::::::::::::BB             a::::ao:::::ooooo:::::o
  H:::::::::::::::::H  u::::u    u::::u  o::::o     o::::o       D:::::D     D:::::Do::::o     o::::o  n:::::nnnn:::::ng:::::g     g:::::g        B::::BBBBBB:::::B     aaaaaaa:::::ao::::o     o::::o
  H::::::HHHHH::::::H  u::::u    u::::u  o::::o     o::::o       D:::::D     D:::::Do::::o     o::::o  n::::n    n::::ng:::::g     g:::::g        B::::B     B:::::B  aa::::::::::::ao::::o     o::::o
  H:::::H     H:::::H  u::::u    u::::u  o::::o     o::::o       D:::::D     D:::::Do::::o     o::::o  n::::n    n::::ng:::::g     g:::::g        B::::B     B:::::B a::::aaaa::::::ao::::o     o::::o
  H:::::H     H:::::H  u:::::uuuu:::::u  o::::o     o::::o       D:::::D    D:::::D o::::o     o::::o  n::::n    n::::ng::::::g    g:::::g        B::::B     B:::::Ba::::a    a:::::ao::::o     o::::o
HH::::::H     H::::::HHu:::::::::::::::uuo:::::ooooo:::::o     DDD:::::DDDDD:::::D  o:::::ooooo:::::o  n::::n    n::::ng:::::::ggggg:::::g      BB:::::BBBBBB::::::Ba::::a    a:::::ao:::::ooooo:::::o
H:::::::H     H:::::::H u:::::::::::::::uo:::::::::::::::o     D:::::::::::::::DD   o:::::::::::::::o  n::::n    n::::n g::::::::::::::::g      B:::::::::::::::::B a:::::aaaa::::::ao:::::::::::::::o
H:::::::H     H:::::::H  uu::::::::uu:::u oo:::::::::::oo      D::::::::::::DDD      oo:::::::::::oo   n::::n    n::::n  gg::::::::::::::g      B::::::::::::::::B   a::::::::::aa:::aoo:::::::::::oo 
HHHHHHHHH     HHHHHHHHH    uuuuuuuu  uuuu   ooooooooooo        DDDDDDDDDDDDD           ooooooooooo     nnnnnn    nnnnnn    gggggggg::::::g      BBBBBBBBBBBBBBBBB     aaaaaaaaaa  aaaa  ooooooooooo   
                                                                                                                                   g:::::g                                                            
                                                                                                                       gggggg      g:::::g                                                            
                                                                                                                       g:::::gg   gg:::::g                                                            
                                                                                                                        g::::::ggg:::::::g                                                            
                                                                                                                         gg:::::::::::::g                                                             
                                                                                                                           ggg::::::ggg                                                               
                                                                                                                              gggggg                                                                  

guandb.cn/${process.env.BRANCH}-${process.env.VERSION} ${process.env.LAST_COMMIT_DATETIME}`
    console.log(`%c${text}`, 'color: #fc4d50')
}

export function random(length: number): string {
    let str = Math.random().toString(36).slice(2)
    if (str.length >= length) return str.slice(0, length)
    str += random(length - str.length)
    return str
}

export const fileResize = (f: UploadFile): Promise<UploadFile> => {
    return new Promise((resolve, reject) => {
        if ((f.size ?? 0) < 1024 * 1024) {
            resolve(f)
            return
        }
        const reader = new FileReader();
        const img = new Image();
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        img.onload = () => {
            const h = (img.height / img.width) * 1080
            canvas.width = 1080
            canvas.height = h
            ctx?.clearRect(0, 0, canvas.width, canvas.height)
            ctx?.drawImage(img, 0, 0, canvas.width, canvas.height)
            canvas.toBlob(b => {
                console.log(b?.size, f.size)
                if (b) resolve(blobToUploadFile(b))
                else reject('缩略图转换失败')
            }, f.type)
        }
        img.onerror = () => reject('原图加载失败')
        reader.onload = (ev) => typeof ev.target?.result === "string" ? img.src = ev.target.result : null
        reader.readAsDataURL(f as unknown as File);
        reader.onerror = () => reject('文件读取失败')
    })
}

function blobToUploadFile(blob: Blob, name?: string): UploadFile {
    const fileName = name || 'file-' + Math.random().toString(36).substring(2, 8);
    return {
        uid: `${fileName}-${Date.now()}-${Math.random()}`, // 唯一 ID
        name: fileName,
        size: blob.size,
        type: blob.type,
        status: 'done', // 默认完成状态，可改成 'uploading'
        // originFileObj: new File([blob], fileName, { type: blob.type }), // 必须，否则 Upload 无法识别
        url: URL.createObjectURL(blob), // 可选，用于预览
    };
}

export function hash(s: string): number {
    return s.split('').reduce((a, b) => {
        a = ((a << 5) - a) + b.charCodeAt(0);
        return a & a
    }, 0)
}

export function nf(): void {
    //
}

export const SelectWrap = defineComponent({
    props: {
        menuNode: {
            type: Object,
            required: true,
        },
    },
    render() {
        return this.menuNode;
    },
});

export function objCopy(o: any): any {
    return JSON.parse(JSON.stringify(o))
}

export const noPic = 'https://static.pms.guandb.cn/media/system/null.jpg'
export const defaultHeaderImg = 'https://static.pms.guandb.cn/media/system/default_header.jpg'